import Vue from 'vue';
import axios from 'axios';
// import UI from '@govcloud/gdui-alpha-test';
// import UI from '@govcloud/gdui-test';
import promise from 'es6-promise';
// import '@govcloud/gdui-alpha-test/styles/src/theme-sid/index.less';
import '@_src/common/styles/index.less';
import GlobalLayout from '@_src/common/components/global-layout/index.vue';
import GlobalSection from '@_src/common/components/global-section/index.vue';
import * as filters from './utils/filters';
import { loading } from './utils/loading';
import toast from './utils/toast';
import ElementUI from 'element-ui';
import '@govcloud/theme-govcloud/lib/index.css';

promise.polyfill();

// 注册全局的section组件
Vue.component('global-layout', GlobalLayout);
Vue.component('global-section', GlobalSection);

Vue.config.productionTip = false;

// Vue.use(UI);
Vue.use(ElementUI);

Vue.prototype.$axios = axios;
Vue.prototype.$toast = toast;
Vue.prototype.$showLoading = loading.show;
Vue.prototype.$hideLoading = loading.hide;

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

export {
  Vue,
};
